export default {
  config: (state) => {
    return state.config;
  },
  poster: (state) => {
    return state.poster;
  },
  contactUs: (state) => {
    return state.contactUs;
  },
  aboutUs: (state) => {
    return state.aboutUs;
  },
  support: (state) => {
    return state.support;
  },

  socialNetwork: (state) => {
    return state.socialNetwork;
  },
  menu: (state) => {
    return state.menu;
  },

  slides: (state) => {
    return state.slides;
  },

  services: (state) => {
    return state.services;
  },
  servicesById: (state) => {
    return state.servicesById;
  },

  tutorials: (state) => {
    return state.tutorials;
  },
  tutorialsPage: (state) => {
    return state.tutorialsPage;
  },
  tutorial: (state) => {
    return state.tutorial;
  },
  tutorialsPageTotal: (state) => {
    return state.tutorialsPageTotal;
  },
  relatedTutorials: (state) => {
    return state.relatedTutorials;
  },

  categories: (state) => {
    return state.categories;
  },
  loadBtn: (state) => {
    return state.loadBtn;
  },

  galleries: (state) => {
    return state.galleries;
  },
  galleryPage: (state) => {
    return state.galleryPage;
  },
  gallery: (state) => {
    return state.gallery;
  },
  galleryList: (state) => {
    return state.galleryList;
  },
  galleryPageTotal: (state) => {
    return state.galleryPageTotal;
  },

  products: (state) => {
    return state.products;
  },
  productsHome: (state) => {
    return state.productsHome;
  },
  productsPage: (state) => {
    return state.productsPage;
  },
  product: (state) => {
    return state.product;
  },
  productsPageTotal: (state) => {
    return state.productsPageTotal;
  },
  relatedProducts: (state) => {
    return state.relatedProducts;
  },

  blogs: (state) => {
    return state.blogs;
  },
  relatedBlogs: (state) => {
    return state.relatedBlogs;
  },
  blogHome: (state) => {
    return state.blogHome;
  },
  blogsPage: (state) => {
    return state.blogsPage;
  },
  blogsPageTotal: (state) => {
    return state.blogsPageTotal;
  },
  blog: (state) => {
    return state.blog;
  },
  comments: (state) => {
    return state.comments;
  },
  rules: (state) => {
    return state.rules;
  },

  activityFields: (state) => {
    return state.activityFields;
  },
  activityFieldseOptions: (state) => {
    const activityFieldseOptions = [];
    state.activityFields.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      activityFieldseOptions.push(pushItem);
    }
    return activityFieldseOptions;
  },

  province: (state) => {
    return state.province;
  },
  provinceOptions: (state) => {
    const provinceOptions = [];
    state.province.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      provinceOptions.push(pushItem);
    }
    return provinceOptions;
  },
  city: (state) => {
    return state.city;
  },
  cityOptions: (state) => {
    const cityOptions = [];
    state.city.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      cityOptions.push(pushItem);
    }
    return cityOptions;
  },
  customerOpinion: (state) => {
    return state.customerOpinion;
  },
  customerBanners: (state) => {
    return state.customerBanners;
  },
  team: (state) => {
    return state.team;
  },
  poolSessions: (state) => {
    return state.poolSessions;
  },
};
